// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ModalSurveyQuestionResults_modalOverlay__dTufp","surveyQuestionResultsContainer":"ModalSurveyQuestionResults_surveyQuestionResultsContainer__1Cq5N"};